import {DocumentActions, SET_SELECTED_PROJECT_ID, SET_PROJECTS, SET_ALL_PROJECTS, SET_MODAL_OPENED, SET_PROJECT_FORM, SET_PROJECT_FORM_VALUE, SET_IS_EDIT, SET_IS_WITH_APPROVAL, SET_STAKEHOLDER_VALUE, SET_DARK_MODE} from '../actions/project';
import { createTransform } from 'redux-persist';
import _ from 'lodash';
import { Project, ProjectForm } from '../../models/project';
import { StakeHolder } from '../../models/stakeHolder';

interface ProjectState  {
    projects: Project[],
    allProjects: Project[],
    selectedProjectId?: number,
    modalOpened: boolean,
    projectForm?: ProjectForm,
    isEdit: boolean,
    darkModeEnabled: boolean
}

const initialState: ProjectState = {
    projects: [],
    allProjects: [],
    selectedProjectId: undefined,
    modalOpened: false,
    projectForm: undefined,
    isEdit: false,
    darkModeEnabled: false
} 

export const SetTransformProject = createTransform(
    (inboundState: any, key) => { 
     if(key == "selectedProjectId" || key == 'darkModeEnabled')
        return inboundState;

    },
    (outboundState: any, key) => { 
        if(key == "selectedProjectId" || key == 'darkModeEnabled')
            return outboundState;
    },
);


export const projectReducer = (project = initialState, action : DocumentActions): ProjectState => {
    switch (action.type) {
        
        case SET_PROJECTS:
            return {...project, projects: action.payload.projects };

        case SET_ALL_PROJECTS:
            return {...project, allProjects: action.payload.projects };

        case SET_SELECTED_PROJECT_ID:
            return {...project, selectedProjectId: action.payload.id };

        case SET_MODAL_OPENED:
            return {...project, modalOpened: action.payload.value };

        case SET_IS_EDIT:
            return {...project, isEdit: action.payload.value };

        case SET_PROJECT_FORM:
            return {...project, projectForm: action.payload.projectForm };

        case SET_STAKEHOLDER_VALUE:
            return {...project, projectForm:  (project.projectForm) ? {...project.projectForm, stakeHolders: _.map([...project.projectForm.stakeHolders], s => {return (s.stakeHolderId === action.payload.id) ? {...s, [action.payload.name]: action.payload.value} : s}) } : undefined}

        case SET_PROJECT_FORM_VALUE:
            return {...project, projectForm: (project.projectForm) ? {...project.projectForm, [action.payload.name]: action.payload.value} : undefined };

        case SET_IS_WITH_APPROVAL:
            return {...project, projectForm: (project.projectForm) ? {...project.projectForm, purposeList: _.map([...project.projectForm.purposeList], p => {return (p.purposeId === action.payload.purposeId) ? {...p, isWithApproval: action.payload.value} : p})} : undefined};

        case SET_DARK_MODE:
            return {...project, darkModeEnabled: action.payload.value };


        default:
            return project;
    }
};

//select from state (read) 
const selectProjectState = (state: any) => state.project as ProjectState;
export const getProjects = (state: any) => selectProjectState(state).projects;
export const getAllProjects = (state: any) => selectProjectState(state).allProjects;
export const getSelectedProjectId = (state: any) => selectProjectState(state).selectedProjectId;
export const getModalOpened = (state: any) => selectProjectState(state).modalOpened;
export const getIsEdit = (state: any) => selectProjectState(state).isEdit;
export const getDarkModeEnabled = (state: any) => selectProjectState(state).darkModeEnabled;
export const getProjectForm = (state: any) => selectProjectState(state).projectForm;
export const getProjectFormProjectCodeword = (state: any) => (selectProjectState(state).projectForm) ? (selectProjectState(state).projectForm as ProjectForm).projectCodeword : undefined;
export const getProjectFormName = (state: any) => (selectProjectState(state).projectForm) ? (selectProjectState(state).projectForm as ProjectForm).projectName : undefined;
export const getProjectFormIsEnabled = (state: any) => (selectProjectState(state).projectForm) ? (selectProjectState(state).projectForm as ProjectForm).isEnabled : false;
export const getProjectFormAutomaticApprovalDays = (state: any) => (selectProjectState(state).projectForm) ? (selectProjectState(state).projectForm as ProjectForm).automaticApprovalDays : 0;
export const getProjectFormMandatoryDrawingColumns= (state: any) => (selectProjectState(state).projectForm) ? (selectProjectState(state).projectForm as ProjectForm).mandatoryDrawingColumns : [];
export const getProjectFormMandatoryDocumentColumns= (state: any) => (selectProjectState(state).projectForm) ? (selectProjectState(state).projectForm as ProjectForm).mandatoryDocumentColumns : [];
export const getProjectFormTemplate= (state: any) => (selectProjectState(state).projectForm) ? (selectProjectState(state).projectForm as ProjectForm).template : undefined;
export const getProjectFormPurposes= (state: any) => (selectProjectState(state).projectForm) ? (selectProjectState(state).projectForm as ProjectForm).purposeList : [];
export const getProjectFormStakeholders = (state: any) => (selectProjectState(state).projectForm) ? (selectProjectState(state).projectForm as ProjectForm).stakeHolders : [];
export const getProjectFormReports = (state: any) => (selectProjectState(state).projectForm) ? (selectProjectState(state).projectForm as ProjectForm).reports : [];